<div
  class="row"
  *ngIf="
    !pageConfig?.isVisibleAuditPage &&
    !isVisibleSmsTemplateAuditPage &&
    !pageConfig?.isVisibleHelpPage
  "
>
  <!-- sms template group -->
  <div class="md:tw-w-1/2 tw-pl-0" [class]="querySelectorPrefix + 'container'">
    <app-page-template
      [showParent]="showParent"
      (clearQueryString)="onClearQueryString()"
      [config]="pageConfig"
      [bodyClass]="input_isModalMode ? 'tw-p-3' : 'tw-pt-3 tw-pl-3  tw-pr-5'"
      (onAdd)="onCreate('', true)"
      (sortObject)="getSortItems($event)"
      (onShowAuditPage)="onShowAuditPage()"
      (onShowHelpPage)="onShowHelpPage()"
      (comparisonObjects)="getComparisonObjects($event)"
      (pageNumber)="changePageNumber($event)"
      (pageSize)="changePageSize($event)"
    >
      <!-------------------------------------- Table Content -------------------------------------->

      <ng-container table-body *ngIf="items && !pageConfig.loading">
        <ng-container
          *ngFor="let item of items; let i = index; trackBy: trackByItems"
        >
          <!---------------------- level1 ---------------------->
          <tr
            [id]="querySelectorPrefix + item.id"
            [attr.data-id]="item.id"
            [attr.data-parentId]="item.parentId"
            [attr.data-level]="1"
            [class]="i == 0 ? 'row-active' : ''"
          >
            <td class="tw-p-0" (click)="onSelect(item)"></td>

            <td class="dir-rtl">
              <div class="tw-flex tw-items-center">
                <div
                  [class]="
                    input_isModalMode ? 'vertical-line-sm' : 'vertical-line'
                  "
                ></div>

                <!-- btn -->
                <div class="tw-w-[30px] tw-flex-center tw-cursor-pointer">
                  <i
                    class="menu-btn bg-light-success tw-rounded-[5px] mdi mdi-plus text-success mdi-20px tw-mx-2 tw-my-1 text-gray"
                    (click)="
                      getSmsTemplateGroupByParentIdApi(
                        item.id,
                        item.subItems,
                        $event.target
                      )
                    "
                  >
                  </i>
                </div>

                <!-- title -->
                <div
                  class="tw-p-0 tw-pr-0 tw-text-right tw-w-full"
                  (click)="onSelect(item)"
                >
                  <div class="tw-flex tw-justify-end tw-items-center">
                    <td-value
                      fontSize="md"
                      class="tree-item-title"
                      [value]="item?.title"
                    >
                    </td-value>
                  </div>
                </div>
              </div>
            </td>

            <!-- operation btns -->
            <td class="sticky-td">
              <!-- operations -->
              <div app-menu-btn [matMenuTriggerFor]="menuLevel1" [isShowDotsMenu]="true"></div>

              <mat-menu #menuLevel1="matMenu" xPosition="before">
                <!-- edit button -->
                <div 
                    app-menu-btn
                    icon="edit"
                    (click)="onUpdate(item.id)">
                </div>

                <!-- delete button -->               
              <div app-menu-btn icon="delete" (click)="onDelete(item)"></div>
              </mat-menu>
            </td>
          </tr>
          <!--------------------- level2 --------------------->
          <ng-container *ngIf="item?.subItems != null">
            <ng-container *ngFor="let item2 of item.subItems">
              <tr
                [id]="querySelectorPrefix + item2.id"
                [attr.data-id]="item2.id"
                [attr.data-parentId]="item2.parentId"
                [attr.data-level]="2"
                class="d-none"
                [class]="selectedItem?.id == item2.id ? 'row-active' : ''"
                (click)="onSelect(item2)"
              >
                <td class="tw-p-0"></td>

                <td class="dir-rtl">
                  <div class="tw-flex tw-items-center">
                    <div
                      [class]="
                        input_isModalMode ? 'vertical-line-sm' : 'vertical-line'
                      "
                    ></div>
                    <div
                      [class]="
                        input_isModalMode
                          ? 'vertical-line-sm2'
                          : 'vertical-line2'
                      "
                    ></div>

                    <!-- btn -->
                    <div
                      class="tw-w-[30px] tw-mr-[30px] ltr:tw-ml-[30px] tw-flex-center tw-cursor-pointer"
                    >
                      <i
                        class="menu-btn bg-light-success tw-rounded-[5px] mdi mdi-plus text-success mdi-20px tw-mx-2 tw-my-1 text-gray"
                        (click)="
                          getSmsTemplateGroupByParentIdApi(
                            item2.id,
                            item2.subItems,
                            $event.target
                          )
                        "
                      >
                      </i>
                    </div>

                    <!-- title -->
                    <div
                      class="tw-p-0 tw-pr-0 tw-text-right tw-w-full"
                      (click)="onSelect(item2)"
                    >
                      <div class="tw-flex tw-justify-end tw-items-center">
                        <td-value
                          fontSize="md"
                          class="tree-item-title"
                          [value]="item2?.title"
                        >
                        </td-value>
                      </div>
                    </div>
                  </div>
                </td>

                <!-- operation btns -->
                <td class="tw-py-0 tw-text-center">
                  <!-- operations -->
                  <div app-menu-btn [matMenuTriggerFor]="menuLevel2" [isShowDotsMenu]="true"></div>

                  <mat-menu #menuLevel2="matMenu" xPosition="before">

                    <!-- edit button -->
                    <div 
                      app-menu-btn
                      icon="edit"
                      (click)="onUpdate(item2.id)">
                    </div>  

                    <!-- delete button -->
                    <div app-menu-btn icon="delete" (click)="onDelete(item2)"></div>
                  
                  </mat-menu>
                </td>
              </tr>
              <!---------------------- level3 ---------------------->
              <ng-container *ngIf="item2?.subItems != null">
                <ng-container *ngFor="let item3 of item2.subItems">
                  <tr
                    [id]="querySelectorPrefix + item3.id"
                    [attr.data-id]="item3.id"
                    [attr.data-parentId]="item3.parentId"
                    [attr.data-level]="3"
                    class="d-none"
                    [class]="selectedItem?.id == item3.id ? 'row-active' : ''"
                  >
                    <td (click)="onSelect(item3)"></td>

                    <td class="dir-rtl">
                      <div class="tw-flex tw-items-center">
                        <div
                          [class]="
                            input_isModalMode
                              ? 'vertical-line-sm'
                              : 'vertical-line'
                          "
                        ></div>
                        <div
                          [class]="
                            input_isModalMode
                              ? 'vertical-line-sm2'
                              : 'vertical-line2'
                          "
                        ></div>
                        <div
                          [class]="
                            input_isModalMode
                              ? 'vertical-line-sm3'
                              : 'vertical-line3'
                          "
                        ></div>

                        <!-- btn -->
                        <div
                          class="tw-w-[30px] tw-mr-[60px] ltr:tw-ml-[60px] tw-flex-center tw-cursor-pointer"
                        >
                          <i
                            class="menu-btn bg-light-success tw-rounded-[5px] mdi mdi-plus text-success mdi-20px tw-mx-2 tw-my-1 text-gray"
                            (click)="
                              getSmsTemplateGroupByParentIdApi(
                                item3.id,
                                item3.subItems,
                                $event.target
                              )
                            "
                          >
                          </i>
                        </div>

                        <!-- title -->
                        <div
                          class="tw-p-0 tw-pr-0 tw-text-right tw-w-full"
                          (click)="onSelect(item3)"
                        >
                          <div class="tw-flex tw-justify-end tw-items-center">
                            <td-value
                              fontSize="md"
                              class="tree-item-title"
                              [value]="item3?.title"
                            >
                            </td-value>
                          </div>
                        </div>
                      </div>
                    </td>

                    <!-- operation btns -->
                    <td class="tw-py-0 tw-text-center">
                      <!-- operations -->
                      <div app-menu-btn [matMenuTriggerFor]="menuLevel3" [isShowDotsMenu]="true"></div>

                      <mat-menu #menuLevel3="matMenu" xPosition="before">

                        <!-- edit button -->
                        <div 
                          app-menu-btn
                          icon="edit"
                          (click)="onUpdate(item3.id)">
                        </div> 

                        <!-- delete button -->
                        <div app-menu-btn icon="delete" (click)="onDelete(item3)"></div>

                      </mat-menu>
                    </td>
                  </tr>
                  <!----------------------- level4 ----------------------->
                  <ng-container *ngIf="item3?.subItems != null">
                    <ng-container *ngFor="let item4 of item3.subItems">
                      <tr
                        [id]="querySelectorPrefix + item4.id"
                        [attr.data-id]="item4.id"
                        [attr.data-parentId]="item4.parentId"
                        [attr.data-level]="4"
                        class="d-none"
                        [class]="
                          selectedItem?.id == item4.id ? 'row-active' : ''
                        "
                      >
                        <td class="tw-p-0" (click)="onSelect(item4)"></td>

                        <td class="dir-rtl">
                          <div class="tw-flex tw-items-center">
                            <div
                              [class]="
                                input_isModalMode
                                  ? 'vertical-line-sm'
                                  : 'vertical-line'
                              "
                            ></div>
                            <div
                              [class]="
                                input_isModalMode
                                  ? 'vertical-line-sm2'
                                  : 'vertical-line2'
                              "
                            ></div>
                            <div
                              [class]="
                                input_isModalMode
                                  ? 'vertical-line-sm3'
                                  : 'vertical-line3'
                              "
                            ></div>
                            <div
                              [class]="
                                input_isModalMode
                                  ? 'vertical-line-sm4'
                                  : 'vertical-line4'
                              "
                            ></div>

                            <!-- btn -->
                            <div
                              class="tw-w-[30px] tw-mr-[90px] ltr:tw-ml-[90px] tw-flex-center tw-cursor-pointer"
                            >
                              <i
                                class="menu-btn bg-light-success tw-rounded-[5px] mdi mdi-plus text-success mdi-20px tw-mx-2 tw-my-1 text-gray"
                                (click)="
                                  getSmsTemplateGroupByParentIdApi(
                                    item4.id,
                                    item4.subItems,
                                    $event.target
                                  )
                                "
                              >
                              </i>
                            </div>

                            <!-- title -->
                            <div
                              class="tw-p-0 tw-pr-0 tw-text-right tw-w-full"
                              (click)="onSelect(item4)"
                            >
                              <div
                                class="tw-flex tw-justify-end tw-items-center"
                              >
                                <td-value
                                  fontSize="md"
                                  class="tree-item-title"
                                  [value]="item4?.title"
                                >
                                </td-value>
                              </div>
                            </div>
                          </div>
                        </td>




                        <!-- operation btns -->
                        <td class="tw-py-0 tw-text-center">
                          <!-- operations -->
                          <div app-menu-btn [matMenuTriggerFor]="menuLevel4" [isShowDotsMenu]="true"></div>

                          <mat-menu #menuLevel4="matMenu" xPosition="before">
                            <!-- edit button -->
                            <div 
                                app-menu-btn
                                icon="edit"
                                (click)="onUpdate(item4.id)">
                            </div> 

                            <!-- delete button -->
                            <div app-menu-btn icon="delete" (click)="onDelete(item4)"></div>

                          </mat-menu>
                        </td>
                      </tr>
                      <!---------------------- level5 ---------------------->
                      <ng-container *ngIf="item4?.subItems != null">
                        <ng-container *ngFor="let item5 of item4.subItems">
                          <tr
                            [id]="querySelectorPrefix + item5.id"
                            [attr.data-id]="item5.id"
                            [attr.data-parentId]="item5.parentId"
                            [attr.data-level]="5"
                            class="d-none"
                            [class]="
                              selectedItem?.id == item5.id ? 'row-active' : ''
                            "
                            (click)="onSelect(item5)"
                          >
                            <td class="tw-p-0" (click)="onSelect(item5)"></td>

                            <td class="dir-rtl">
                              <div class="tw-flex tw-items-center">
                                <div
                                  [class]="
                                    input_isModalMode
                                      ? 'vertical-line-sm'
                                      : 'vertical-line'
                                  "
                                ></div>
                                <div
                                  [class]="
                                    input_isModalMode
                                      ? 'vertical-line-sm2'
                                      : 'vertical-line2'
                                  "
                                ></div>
                                <div
                                  [class]="
                                    input_isModalMode
                                      ? 'vertical-line-sm3'
                                      : 'vertical-line3'
                                  "
                                ></div>
                                <div
                                  [class]="
                                    input_isModalMode
                                      ? 'vertical-line-sm4'
                                      : 'vertical-line4'
                                  "
                                ></div>
                                <div
                                  [class]="
                                    input_isModalMode
                                      ? 'vertical-line-sm5'
                                      : 'vertical-line5'
                                  "
                                ></div>

                                <!-- btn -->
                                <div
                                  class="tw-w-[30px] tw-mr-[120px] tw-flex-center tw-cursor-pointer"
                                >
                                  <i
                                    class="menu-btn bg-light-success tw-rounded-[5px] mdi mdi-plus text-success mdi-20px tw-mx-2 tw-my-1 text-gray"
                                    (click)="
                                      getSmsTemplateGroupByParentIdApi(
                                        item5.id,
                                        item5.subItems,
                                        $event.target
                                      )
                                    "
                                  >
                                  </i>
                                </div>

                                <!-- title -->
                                <div
                                  class="tw-p-0 tw-pr-0 tw-text-right tw-w-full"
                                  (click)="onSelect(item5)"
                                >
                                  <div
                                    class="tw-flex tw-justify-end tw-items-center"
                                  >
                                    <td-value
                                      fontSize="md"
                                      class="tree-item-title"
                                      [value]="item5?.title"
                                    >
                                    </td-value>
                                  </div>
                                </div>
                              </div>
                            </td>

                            <!-- operation btns -->
                            <td class="tw-py-0 tw-text-center">
                              <!-- operations -->
                              <div app-menu-btn [matMenuTriggerFor]="menuLevel5" [isShowDotsMenu]="true"></div>

                              <mat-menu
                                #menuLevel5="matMenu"
                                xPosition="before"
                              >
                                <!-- edit button -->
                                <div 
                                    app-menu-btn
                                    icon="edit"
                                    (click)="onUpdate(item5.id)">
                                </div> 

                                <!-- delete button -->
                                <div app-menu-btn icon="delete" (click)="onDelete(item5)"></div>
                                
                              </mat-menu>
                            </td>
                          </tr>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </app-page-template>
  </div>

  <!------------------------- sms template group ------------------------->
  <div class="md:tw-w-1/2 border-right tw-pr-0">
    <app-sms-template
      [isSmallSizePage]="true"
      [showAuditBtn]="input_isShowAuditBtn"
      [group]="selectedItem"
      [isModalMode]="input_isModalMode"
      (isVisibleAuditPage)="isVisibleSmsTemplateAuditPage = $event"
      (selectedSmsTemplate)="emitSelectedSmsTemplate($event)"
    >
    </app-sms-template>
  </div>
</div>

<!--------------------- Audit smsTemplateGroup --------------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>
<!--------------------- Audit smsTemplates --------------------->
<ng-container *ngIf="isVisibleSmsTemplateAuditPage">
  <app-audit
    [service]="smsTemplatesService"
    methodName="smsTemplatesGetSmsTemplatesAudit"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--------------------------------------- help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="'SmsTemplate'"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
